module.exports = __webpack_public_path__ + "static/media/sculpture-4.7fc35e6e.jpg";